import ClientPage from "./pages/ClientPages/ClientPage";
import WorkOrderAnalyticsDashboardPage from "./pages/WorkOrderPages/WorkOrderAnalyticsDashboardPage.js";
import CompanySettingsPage from "./pages/CompanyPages/CompanySettingsPage";
import CompleteYourProfilePage from "./pages/CompleteYourProfilePage";
import FindJobPage from "./pages/FindJobPages/FindJobPage";
import JobDetailsPage from "./pages/FindJobPages/JobDetailsPage";
import EngineerDashboardPage from "./pages/FindJobPages/EngineerDashboardPage";
import CustomerDashboardPage from "./pages/CustomerDashboardPage";
import CustomerSettingsPage from "./pages/CustomerPages/CustomerSettingsPage";
import CreateCustomerEntityPage from "./pages/CustomerPages/CreateCustomerEntityPage";
import CustomerUsers from "./views/CustomerSettings/Users";
import CustomerEntities from "./views/CustomerSettings/Entities";
import CustomerCompanyDetails from "./views/CustomerSettings/CompanyDetails";
import ProfileDetailPage from "./pages/ProfilePages/ProfileDetailPage";
import ProfileSettingsPage from "./pages/ProfilePages/ProfileSettingsPage";
import CreateWorkOrderPage from "./pages/WorkOrderPages/CreateWorkOrderPage";
import CreateEditClientPage from "./pages/ClientPages/CreateEditClientPage";
import ViewClientPage from "./pages/ClientPages/ViewClientPage";
import WorkOrderPage from "./pages/WorkOrderPages/WorkOrderPage";
import CompanyUsers from "./views/CompanySettings/CompanyUsers";

import ProfileTab from "./views/ProfileDetails/ProfileTab";
import ChangePassword from "./views/ProfileSettings/ChangePassword";
import PersonalInformation from "./views/ProfileSettings/PersonalInformation";
import ProfileSetting from "./views/ProfileSettings/ProfileSetting";
import ChatTab from "./views/WorkJobDetails/Tabs/ChatTab";

import DetailsTab from "./views/WorkJobDetails/Tabs/DetailsTab";
import HistoryTab from "./views/WorkJobDetails/Tabs/HistoryTab";
import PayTab from "./views/WorkJobDetails/Tabs/PayTab";
import ProposalsTab from "./views/WorkJobDetails/Tabs/ProposalsTab";
import ProvidersTab from "./views/WorkJobDetails/Tabs/ProvidersTab";
import SignOffTab from "./views/WorkJobDetails/Tabs/SignOffTab";
import Assessment from "./views/WorkOrder/Steps/Assessment";
import Scheduling from "./views/WorkOrder/Steps/Scheduling";
import Summary from "./views/WorkOrder/Steps/Summary";
import WorkPay from "./views/WorkOrder/Steps/WorkPay";
import ProjectPage from "./pages/ProjectPages/ProjectPage";
import CreateEditProjectPage from "./pages/ProjectPages/CreateEditProjectPage";
import FeedbackTab from "./views/WorkJobDetails/Tabs/FeedbackTab";
import CategoryTable from "./views/WorkExperience/CategoryTable";
import VendorsTable from "./views/WorkExperience/VendorsTable";
import ProductsTable from "./views/WorkExperience/ProductsTable";
import WorkExperiencePage from "./pages/WorkExperiencePages/WorkExperiencePage";
import QualificationsTable from "./views/Qualifications/QualificationsTable";
import SubQualificationsTable from "./views/Qualifications/SubQualificationsTable";
import QualificationPage from "./pages/QualificationPages/QualificationPage";
import WorkForcePage from "./pages/WorkForcePages/WorkForcePage";
import WorkForceDashboardPage from "./pages/WorkForcePages/WorkForceDashboardPage";
import TalentPoolsPage from "./pages/WorkForcePages/TalentPoolsPage";
import NewUsersPage from "./pages/AdminPages/NewUsersPage";
import CompanyTable from "./views/NewUsers/CompanyTable";
import CustomersTable from "./views/NewUsers/CustomersTable";
import CustomerDetails from "./views/NewUsers/CustomerDetails";
import EngineersTable from "./views/NewUsers/EngineersTable";
import CLientUsersTable from "./views/NewUsers/CompanyUsersTable";
import FreelanceCompanyMembersTable from "./views/NewUsers/FreelanceCompanyMembersTable";
import UpdateSettings from "./views/CompanySettings/Settings/CreateEditCompanySettings";
import ClientSettings from "./views/CompanySettings/Settings";
import TalentPoolEngineersPage from "./pages/WorkForcePages/TalentPoolEngineersPage";
import WorkForceFreelanceCompaniesPage from "./pages/WorkForcePages/WorkForceFreelanceCompaniesPage";
import WorkForceFreelanceCompanyDetailsPage from "./pages/WorkForcePages/WorkForceFreelanceCompanyDetailsPage";
import CustomerWorkOrderPage from "./pages/WorkOrderPages/CustomerWorkOrderPage";
import CustomerInvoicesPage from "./pages/InvoicePages/CustomerInvoicesPage";
import EngineerInvoicesPage from "./pages/InvoicePages/EngineerInvoicesPage";
import EditInvoicePage from "./pages/InvoicePages/EditInvoicePage";
import InvoiceAnalyticsDashboardPage from "./pages/InvoicePages/InvoiceAnalyticsDashboardPage";
import CompanyBranches from "./views/CompanySettings/CompanyBranches";
import BankAccounts from "./views/CompanySettings/BankAccounts";
import EngineerBankAccount from "./views/ProfileSettings/EngineerBankAccount";
import LinkedCompanies from "./views/ProfileSettings/LinkedCompanies";
import UserPermissionsPage from "./pages/AdminPages/UserPermissionsPage";
import RoleManagement from "./views/CompanySettings/RoleManagement";
import PermissionsPage from "./pages/PermissionPages/PermissionsPage";
import WorkBoard from "./views/Permissions/tabs/WorkBoard";
import ClientListingTable from "./views/Client/ClientListingTable";
import ClientAccountTable from "./views/Client/ClientAccount/ClientAccountTable";
import CreateEditClientAccount from "./views/Client/CreateEditClientAccount";
import Invoices from "./views/Permissions/tabs/Invoices";
import WorkForce from "./views/Permissions/tabs/WorkForce.js";
import CompanyTeams from "./views/CompanySettings/CompanyTeams";
import CompanyDepartments from "./views/CompanySettings/CompanyDepartments";
import GeneralPermissions from "./views/Permissions/tabs/GeneralPermissions.js";
import TaskBoardPage from "./pages/TaskBoardPages/TaskBoardPage.js";
import TaskBoardPermissions from "./views/Permissions/tabs/TaskBoardPermissions.js";
import ClientWorkOrderPage from "./pages/WorkOrderPages/ClientWorkOrderPage.js";
import WorkersPage from "./pages/FreelanceCompanyPages/WorkersPage";
import ParentCustomerDetailsPage from "./pages/ClientPages/ParentCustomerDetailsPage";

const routes = [
  {
    module: "WORK_ORDERS",
    // Customers reuse the exact same create page to raise a ticket; the backend
    // creates it as PENDING_APPROVAL for a client to review and publish.
    modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
    path: "workOrder/create",
    component: <CreateWorkOrderPage />,
    childs: [
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        text: "Summary",
        path: "summary",
        component: <Summary />,
      },
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        text: "Scheduling",
        path: "scheduling",
        component: <Scheduling />,
      },
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        text: "Payment",
        path: "payment",
        component: <WorkPay />,
      },
      // Assessment stays WORK_ORDERS-only — customers don't get this step.
      {
        module: "WORK_ORDERS",
        text: "Assessment",
        path: "assessment",
        component: <Assessment />,
      },
    ],
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "WORK_ORDERS",
    // Customers reuse the same edit page for the work orders within their scope,
    // so accept CLIENT_WORK_ORDERS too — the API re-checks that scope on save.
    modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
    path: "workOrder/edit",
    component: <CreateWorkOrderPage />,
    childs: [
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        path: "summary/:id",
      },
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        path: "scheduling/:id",
      },
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        path: "payment/:id",
      },
      {
        module: "WORK_ORDERS",
        modules: ["WORK_ORDERS", "CLIENT_WORK_ORDERS"],
        path: "assessment/:id",
      },
    ],
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "WORK_ORDERS",
    text: "Dashboard",
    path: "workBoard/dashboard",
    icon: <i className="fa-light fa-chart-line text-[26px]"></i>,
    activeIcon: <i className="fa-light fa-chart-line text-[26px] text-primary"></i>,
    isShow: true,
    isShowClient: true,
    component: <WorkOrderAnalyticsDashboardPage />,
    requiredAccess: { isRead: true },
  },
  {
    module: "WORK_ORDERS",
    text: "Work Board",
    path: "workBoard",
    icon: <i className="fa-light fa-briefcase text-[26px]"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-[26px] text-primary"></i>,
    isShow: true,
    isShowClient: true,
    childs: [
      {
        module: "WORK_ORDERS",
        text: "Work Orders",
        path: "workOrders",
        isShowClient: true,
        component: <WorkOrderPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "CUSTOMER_WORK_ORDERS",
        text: "Customer Work Orders",
        path: "customer",
        isShowClient: true,
        component: <CustomerWorkOrderPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "CLIENT_CUSTOMER",
        text: "Customers",
        path: "clients",
        isShowClient: true,
        component: <ClientPage />,
        requiredAccess: { isRead: true },
        tabs: [
          {
            text: "Client Details",
            path: "details",
            component: <ClientListingTable />,
            roles: ["CLIENT"],
          },

          {
            text: "Account",
            path: "account",
            component: <ClientAccountTable />,
            roles: ["CLIENT"],
          },
        ],
      },
      {
        module: "CLIENT_PROJECT",
        text: "Projects",
        path: "projects",
        isShowClient: true,
        component: <ProjectPage />,
        requiredAccess: { isRead: true },
      },

      {
        text: "Deliverables",
        path: "deliverables",
      },
      {
        text: "Client Request",
        path: "client-request",
      },
    ],
  },
  {
    module: "CLIENT_PROJECT",
    path: "workBoard/projects/create",
    component: <CreateEditProjectPage />,
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "CLIENT_PROJECT",
    path: "workBoard/projects/edit/:id",
    component: <CreateEditProjectPage />,
    isShow: false,
    requiredAccess: { isRead: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/create",
    component: <CreateEditClientPage />,
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/edit/:id",
    component: <CreateEditClientPage />,
    isShow: false,
    requiredAccess: { isRead: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/view/:id",
    component: <ViewClientPage />,
    isShow: false,
    requiredAccess: { isRead: true },
  },
  {
    // A page of its own rather than a tab under Accounts: the entity record fills
    // the shell the same way it does on the customer side.
    module: "ADMIN_NEW_USERS_MANAGEMENT",
    path: "admin/customers/entity/:id",
    component: <ViewClientPage />,
    isShow: false,
    isShowClient: false,
    requiredAccess: { isRead: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/:parentClientId",
    component: <ParentCustomerDetailsPage />,
    isShow: false,
    requiredAccess: { isRead: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/:parentClientId/create",
    component: <CreateEditClientPage />,
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/account/create",
    component: <CreateEditClientAccount />,
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "CLIENT_CUSTOMER",
    path: "workBoard/clients/account/edit/:id",
    component: <CreateEditClientAccount />,
    isShow: false,
    requiredAccess: { isWrite: true },
  },
  {
    module: "JOBS",
    text: "Analytics",
    icon: <i className="fa-light fa-chart-line text-3xl"></i>,
    activeIcon: <i className="fa-light fa-chart-line text-3xl text-primary"></i>,
    path: "engineer/analytics",
    component: <EngineerDashboardPage />,
    isShow: true,
    isShowClient: false,
    requiredAccess: { isRead: true },
  },
  {
    module: "JOBS",
    text: "Job",
    icon: <i className="fa-light fa-briefcase text-3xl"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-3xl text-primary"></i>,
    path: "jobs",
    component: <FindJobPage />,
    isShow: true,
    isShowClient: false,
    requiredAccess: { isRead: true },
  },
  {
    // Customer-only analytics. isShowClient:false keeps it out of the client and
    // admin sidebars; the API refuses any non-customer caller regardless.
    module: "CLIENT_WORK_ORDERS",
    text: "Dashboard",
    icon: <i className="fa-light fa-chart-line text-[26px]"></i>,
    activeIcon: <i className="fa-light fa-chart-line text-[26px] text-primary"></i>,
    path: "customerDashboard",
    component: <CustomerDashboardPage />,
    isShow: true,
    isShowClient: false,
    isShowCustomer: true,
    roles: ["CUSTOMER"],
    requiredAccess: { isRead: true },
  },
  {
    module: "CLIENT_WORK_ORDERS",
    text: "Work Orders",
    icon: <i className="fa-light fa-briefcase text-[26px]"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-[26px] text-primary"></i>,
    path: "workOrders",
    component: <ClientWorkOrderPage />,
    isShow: true,
    isShowClient: false,
    requiredAccess: { isRead: true },
  },

  {
    module: "TASK_BOARD",
    text: "Task Board",
    icon: <i className="fa-light fa-list-check text-3xl"></i>,
    activeIcon: <i className="fa-light fa-list-check text-3xl text-primary"></i>,
    path: "taskBoard/:id?",
    component: <TaskBoardPage />,
    isShow: true,
    isShowClient: true,
  },
  {
    module: "",
    isFreelanceCompanyRoute: true,
    text: "Workers",
    path: "workers",
    icon: <i className="fa-solid fa-people-group text-[26px]"></i>,
    activeIcon: <i className="fa-solid fa-people-group text-[26px] text-primary"></i>,
    component: <WorkersPage />,
    isShow: true,
    isShowClient: false,
  },
  {
    module: "",
    text: "Job Details",
    icon: <i className="fa-light fa-briefcase text-3xl"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-3xl text-primary"></i>,
    path: "/workOrder",
    component: <JobDetailsPage />,
    isShow: false,
    // requiredAccess: { isRead: true },
    childs: [
      {
        module: "",
        text: "Details",
        path: "details/:id",
        component: <DetailsTab />,
        roles: ["CLIENT", "FREELANCER", "CUSTOMER"],
        statuses: [
          "DRAFT",
          "PENDING_APPROVAL",
          "PUBLISHED",
          "ASSIGNED",
          "INPROGRESS",
          "WORKDONE",
          "INCOMPLETE",
          "VERIFIED",
          "APPROVED",
          "INVOICED",
          "DISPUTED",
          "PAID",
          "CANCELLED",
        ],
      },
      {
        module: "",
        text: "Payment",
        path: "payment/:id",
        component: <PayTab />,
        roles: ["CLIENT", "FREELANCER", "CUSTOMER"],
        statuses: [
          "DRAFT",
          "PENDING_APPROVAL",
          "PUBLISHED",
          "ASSIGNED",
          "INPROGRESS",
          "WORKDONE",
          "INCOMPLETE",
          "VERIFIED",
          "APPROVED",
          "INVOICED",
          "DISPUTED",
          "PAID",
          "CANCELLED",
        ],
      },
      {
        // The counter offers a client sent the customer on their ticket, which the
        // customer sees as offers. The path keeps its old name so existing links
        // and the tab routing still resolve.
        module: "",
        text: "Offers",
        path: "proposals/:id",
        component: <ProposalsTab />,
        roles: ["CUSTOMER"],
        statuses: [
          "DRAFT",
          "PENDING_APPROVAL",
          "PUBLISHED",
          "ASSIGNED",
          "INPROGRESS",
          "WORKDONE",
          "INCOMPLETE",
          "VERIFIED",
          "APPROVED",
          "INVOICED",
          "DISPUTED",
          "PAID",
          "CANCELLED",
        ],
      },
      {
        module: "",
        text: "Providers",
        path: "providers/:id",
        component: <ProvidersTab />,
        roles: ["CLIENT"],
        statuses: [
          "DRAFT",
          "PENDING_APPROVAL",
          "PUBLISHED",
          "ASSIGNED",
          "INPROGRESS",
          "WORKDONE",
          "VERIFIED",
          "INCOMPLETE",
          "APPROVED",
          "INVOICED",
          "DISPUTED",
          "PAID",
          "CANCELLED",
        ],
      },
      {
        module: "",
        text: "Messages",
        path: "messages/:id",
        component: <ChatTab />,
        roles: ["CLIENT", "FREELANCER", "CUSTOMER"],
        statuses: [
          "PENDING_APPROVAL",
          "PUBLISHED",
          "ASSIGNED",
          "INPROGRESS",
          "WORKDONE",
          "VERIFIED",
          "INCOMPLETE",
          "APPROVED",
          "INVOICED",
          "DISPUTED",
          "PAID",
          "CANCELLED",
        ],
      },
      {
        module: "",
        text: "Job Sign-Off",
        path: "signoffSheet/:id",
        component: <SignOffTab />,
        roles: ["CLIENT", "FREELANCER", "CUSTOMER"],
        statuses: ["WORKDONE", "VERIFIED", "APPROVED", "INVOICED", "DISPUTED", "PAID"],
      },
      {
        module: "",
        text: "Feedback",
        path: "feedback/:id",
        component: <FeedbackTab />,
        roles: ["CLIENT", "FREELANCER"],
        statuses: ["WORKDONE", "APPROVED", "VERIFIED", "INVOICED", "DISPUTED", "PAID"],
      },
      {
        module: "",
        text: "History",
        path: "history/:id",
        component: <HistoryTab />,
        roles: ["CLIENT"],
        statuses: [
          "DRAFT",
          "PENDING_APPROVAL",
          "PUBLISHED",
          "ASSIGNED",
          "INPROGRESS",
          "WORKDONE",
          "VERIFIED",
          "INCOMPLETE",
          "APPROVED",
          "INVOICED",
          "DISPUTED",
          "PAID",
          "CANCELLED",
        ],
      },
    ],
  },
  {
    module: "",
    path: "completeYourProfile",
    component: <CompleteYourProfilePage />,
    isShow: false,
    isCustomFullPage: true,
    requiredAccess: { isRead: true },
  },
  {
    module: "WORK_FORCE_ENGINEERS",
    text: "Work Force",
    path: "workForce",
    icon: <i className="fa-light fa-users text-[26px]"></i>,
    activeIcon: <i className="fa-light fa-users text-[26px] text-primary"></i>,
    isShow: true,
    isShowClient: true,
    isShowCustomer: true,
    childs: [
      {
        module: "WORK_FORCE_COVERAGE_MAP",
        text: "Coverage Map ",
        path: "coverage",
        isShowClient: true,
        component: <WorkForceDashboardPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "WORK_FORCE_ENGINEERS",
        text: "All Engineers",
        path: "allEngineers",
        isShowClient: true,
        isShowCustomer: true,
        component: <WorkForcePage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "WORK_FORCE_ENGINEERS",
        text: "Vendors",
        path: "freelanceCompanies",
        isShowClient: true,
        isShowCustomer: false,
        component: <WorkForceFreelanceCompaniesPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "WORK_FORCE_ENGINEERS",
        text: "",
        path: "freelanceCompanies/:id",
        component: <WorkForceFreelanceCompanyDetailsPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "WORK_FORCE_TALENT_POOL",
        text: "Talent Pools",
        path: "talentPools",
        isShowClient: true,
        component: <TalentPoolsPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "WORK_FORCE_TALENT_POOL",
        text: "",
        path: "talentPool/engineers/:id",
        component: <TalentPoolEngineersPage />,
        requiredAccess: { isRead: true },
      },
    ],
  },
  {
    module: "MANAGE",
    text: "Manage",
    path: "manage",
    icon: <i className="fa-light fa-list-check text-[26px]"></i>,
    activeIcon: <i className="fa-light fa-list-check text-[26px] text-primary"></i>,
    isShow: true,
    isShowClient: true,
    requiredAccess: { isRead: true },
    childs: [
      {
        module: "WORK_EXPERIENCE",
        text: "Work Experience",
        path: "workExperience/*",
        component: <WorkExperiencePage />,
        isShowClient: true,
        tabs: [
          {
            text: "Technology Stacks",
            path: "category",
            component: <CategoryTable />,
            roles: ["ADMIN"],
          },
          {
            text: "Category",
            path: "vendors",
            component: <VendorsTable />,
            roles: ["ADMIN"],
          },
          {
            text: "Skills",
            path: "products",
            component: <ProductsTable />,
            roles: ["ADMIN"],
          },
        ],
      },
      {
        module: "QUALIFICATIONS",
        text: "Qualifications",
        path: "qualifications/*",
        component: <QualificationPage />,
        isShowClient: true,
        tabs: [
          {
            text: "Qualifications",
            path: "qualifications",
            component: <QualificationsTable />,
            roles: ["ADMIN"],
          },
          {
            text: "Sub-Qualifications",
            path: "subQualifications",
            component: <SubQualificationsTable />,
            roles: ["ADMIN"],
          },
        ],
      },
    ],
  },

  {
    module: "USERS",
    text: "Profile Detail",
    icon: <i className="fa-light fa-briefcase text-3xl"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-3xl text-primary"></i>,
    path: "/user/details",
    isShow: false,
    isShowClient: false,
    requiredAccess: { isRead: true },
    component: <ProfileDetailPage />,
    childs: [
      {
        module: "USERS",
        text: "Personal Info",
        path: "profileInformation/:id",
        component: <PersonalInformation />,
        roles: ["ADMIN", "FREELANCER"],
      },
      {
        module: "USERS",
        text: "Profile",
        path: "profile/:id",
        component: <ProfileTab />,
        roles: ["ADMIN", "CLIENT", "FREELANCER", "CUSTOMER"],
      },
      /* {
        // module: "USER_PERMISSIONS",
        module: "USERS",
        text: "Permissions",
        path: "permissions/:id",
        component: <UserPermissionsPage />,
        roles: ["ADMIN"],
      }, */
      {
        module: "USERS",
        text: "Company Details",
        path: "companyDetails/:id",
        component: <UpdateSettings isFreelanceCompany />,
        roles: ["ADMIN"],
        companyOwnerOnly: true,
      },
      {
        module: "USERS",
        text: "Bank Accounts",
        path: "bankAccounts/:id",
        component: <EngineerBankAccount />,
        roles: ["ADMIN"],
      },
      {
        module: "USERS",
        text: "Workers",
        path: "workers/:id",
        component: <FreelanceCompanyMembersTable hideTitle />,
        roles: ["ADMIN"],
        companyOwnerOnly: true,
      },
      // Availability is only a placeholder heading, so it is hidden for every role.
      // {
      //   module: "USERS",
      //   text: "Availability",
      //   path: "availability/:id",
      //   component: <h1>Availability</h1>,
      //   roles: ["CLIENT", "FREELANCER"],
      // },
      {
        text: "Notes",
        path: "notes/:id",
        component: <h1>Notes</h1>,
        roles: ["CLIENT"],
      },
      {
        text: "Messages",
        path: "messages/:id",
        component: <h1>Messages</h1>,
        roles: ["CLIENT", "FREELANCER"],
      },
      {
        text: "Recommendations",
        path: "recommendations/:id",
        component: <h1>Recommendations</h1>,
        roles: ["CLIENT"],
      },
      {
        text: "Private Feedback",
        path: "privateFeedback/:id",
        component: <h1>Private Feedback</h1>,
        roles: ["CLIENT"],
      },
    ],
  },
  {
    module: "USERS",
    text: "Profile Settings",
    icon: <i className="fa-light fa-briefcase text-3xl"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-3xl text-primary"></i>,
    path: "/user/settings",
    isShow: false,
    isShowClient: false,
    requiredAccess: { isRead: true },
    component: <ProfileSettingsPage />,
    childs: [
      {
        // An engineer's own details, with their professional profile on its own tab.
        module: "USERS",
        text: "Personal Info",
        path: "profileInformation/:id",
        component: <PersonalInformation />,
        roles: ["FREELANCER"],
      },
      {
        module: "USERS",
        text: "Profile",
        path: "profile/:id",
        component: <ProfileSetting withEngineerProfile />,
        roles: ["FREELANCER"],
      },
      {
        module: "USERS",
        text: "Profile",
        path: "profileInformation/:id",
        component: <PersonalInformation withProfileSections />,
        roles: ["CLIENT", "CUSTOMER"],
      },
      {
        module: "USERS",
        text: "Change Password",
        path: "changePassword/:id",
        component: <ChangePassword />,
        roles: ["FREELANCER", "CLIENT", "CUSTOMER"],
      },
      {
        module: "USERS",
        text: "Bank Accounts",
        path: "bankAccounts/:id",
        component: <EngineerBankAccount />,
        roles: ["FREELANCER"],
      },
      {
        module: "USERS",
        text: "Linked Company",
        path: "linkedCompanies/:id",
        component: <LinkedCompanies />,
        roles: ["FREELANCER"],
      },
      {
        text: "Notification",
        path: "notification/:id",
        component: <h1>Notification</h1>,
        roles: ["FREELANCER"],
      },
    ],
  },
  {
    module: "COMPANIES",
    // A freelance company owner holds FREELANCE_COMPANY_WORKERS rather than COMPANIES.
    modules: ["COMPANIES", "FREELANCE_COMPANY_WORKERS"],
    text: "Company Settings",
    icon: <i className="fa-light fa-briefcase text-3xl"></i>,
    activeIcon: <i className="fa-light fa-briefcase text-3xl text-primary"></i>,
    path: "/company",
    isShow: false,
    isShowClient: true,
    requiredAccess: { isWrite: true },
    component: <CompanySettingsPage />,
    childs: [
      {
        module: "COMPANIES",
        text: "Company Details",
        path: "settings",
        component: <ClientSettings />,
        roles: ["CLIENT"],
      },
      {
        module: "FREELANCE_COMPANY_WORKERS",
        text: "Company Details",
        path: "settings",
        component: <ClientSettings isFreelanceCompany />,
        roles: ["FREELANCER"],
        ownerOnly: true,
      },
      {
        module: "COMPANIES",
        text: "Users",
        path: "companyUsers",
        component: <CompanyUsers />,
        roles: ["CLIENT"],
      },
      {
        // module: "ROLE_MANAGEMENT",
        module: "COMPANIES",
        text: "Role Management",
        path: "roleManagement",
        component: <RoleManagement />,
        roles: ["CLIENT"],
      },
      {
        module: "COMPANY_BRANCHES",
        text: "Branches",
        path: "branches",
        component: <CompanyBranches />,
        roles: ["CLIENT"],
      },
      {
        module: "CLIENT_BANK_ACCOUNTS",
        text: "Bank Accounts",
        path: "bankAccounts",
        component: <BankAccounts />,
        roles: ["CLIENT"],
      },
      {
        module: "COMPANIES",
        text: "Teams",
        path: "teams",
        component: <CompanyTeams />,
        roles: ["CLIENT"],
      },
      {
        module: "COMPANIES",
        text: "Departments",
        path: "departments",
        component: <CompanyDepartments />,
        roles: ["CLIENT"],
        ownerOnly: true,
      },
    ],
  },

  {
    // A page of its own, outside the settings tab shell: the Entities tab's "Add
    // Entity" lands here and the form returns to the tab once the entity is saved.
    module: "",
    path: "customerSettings/entities/create",
    isShow: false,
    isShowClient: false,
    component: <CreateCustomerEntityPage />,
  },
  {
    module: "",
    path: "/customerSettings",
    isShow: false,
    isShowClient: false,
    component: <CustomerSettingsPage />,
    childs: [
      {
        module: "",
        text: "Company Details",
        path: "companyDetails",
        component: <CustomerCompanyDetails />,
        roles: ["CUSTOMER"],
      },
      {
        module: "",
        text: "Entities",
        path: "entities",
        component: <CustomerEntities />,
        roles: ["CUSTOMER"],
      },
      {
        module: "",
        text: "Users",
        path: "users",
        component: <CustomerUsers />,
        roles: ["CUSTOMER"],
      },
    ],
  },

  {
    module: "",
    path: "/company/:role/permissions/:id",
    component: <PermissionsPage />,
    isShow: false,
    childs: [
      {
        module: "",
        text: "Workboard",
        path: "workboard",
        component: <WorkBoard />,
        roles: ["CLIENT"],
      },
      {
        module: "",
        text: "Invoices",
        path: "invoices",
        component: <Invoices />,
        roles: ["CLIENT"],
      },

      {
        module: "",
        text: "Work Force",
        path: "workForce",
        component: <WorkForce />,
        roles: ["CLIENT"],
      },
      {
        module: "",
        text: "Task Board",
        path: "taskBoard",
        component: <TaskBoardPermissions />,
        roles: ["CLIENT"],
      },
      {
        module: "",
        text: "General",
        path: "general",
        component: <GeneralPermissions />,
        roles: ["CLIENT"],
      },
    ],
  },

  {
    module: "ADMIN_NEW_USERS_MANAGEMENT",
    text: "Accounts",
    icon: <i className="fa-light fa-user-group text-3xl"></i>,
    activeIcon: <i className="fa-light fa-user-group text-3xl text-primary"></i>,

    path: "/admin/review",
    isShow: true,
    isShowClient: true,
    requiredAccess: { isWrite: true },
    component: <NewUsersPage />,
    childs: [
      {
        module: "ADMIN_NEW_USERS_MANAGEMENT",
        text: "Vendors",
        path: "companies",
        component: <CompanyTable />,
        requiredAccess: { isRead: true },
        isShowClient: true,
        roles: ["ADMIN"],
        // childs: [
        //   {
        //     module: "ADMIN_NEW_USERS_MANAGEMENT",
        //     path: ":id",
        //     text: "Company Users",
        //     component: <CLientUsersTable />,
        //     roles: ["ADMIN"],
        //     requiredAccess: { isRead: true },
        //   },
        // ],
      },
      {
        module: "ADMIN_NEW_USERS_MANAGEMENT",
        text: "Customers",
        path: "customers",
        component: <CustomersTable />,
        requiredAccess: { isRead: true },
        isShowClient: true,
        roles: ["ADMIN"],
      },
      {
        module: "ADMIN_NEW_USERS_MANAGEMENT",
        text: "Engineers",
        path: "engineers",
        isShowClient: true,
        component: <EngineersTable />,
        requiredAccess: { isRead: true },
        roles: ["ADMIN"],
      },
      {
        module: "ADMIN_NEW_USERS_MANAGEMENT",
        path: "companies/:id",
        text: "Company Users",
        isShowClient: false,
        component: <CLientUsersTable />,
        roles: ["ADMIN"],
        requiredAccess: { isRead: true },
      },
      {
        module: "ADMIN_NEW_USERS_MANAGEMENT",
        path: "customers/:id",
        text: "Customer Users",
        isShowClient: false,
        component: <CustomerDetails />,
        roles: ["ADMIN"],
        requiredAccess: { isRead: true },
      },
      {
        module: "ADMIN_NEW_USERS_MANAGEMENT",
        path: "freelanceCompanies/:id",
        text: "Vendor Members",
        isShowClient: false,
        component: <FreelanceCompanyMembersTable />,
        roles: ["ADMIN"],
        requiredAccess: { isRead: true },
      },
    ],
  },

  {
    module: "INVOICE",
    text: "Invoices",
    path: "invoices",
    icon: <i className="fa-light fa-file-invoice-dollar text-[26px] "></i>,
    activeIcon: <i className="fa-light fa-file-invoice-dollar text-[26px] text-primary"></i>,

    isShow: true,
    isShowClient: true,
    isShowCustomer: true,
    childs: [
      {
        module: "CUSTOMER_INVOICE",
        text: "Finance Dashboard",
        path: "analytics",
        isShowClient: true,
        roles: ["CLIENT", "ADMIN"],
        component: <InvoiceAnalyticsDashboardPage />,
        requiredAccess: { isRead: true },
      },
      {
        module: "CUSTOMER_INVOICE",
        text: "Customer Invoices",
        path: "customer",
        isShowClient: true,
        isShowCustomer: true,
        component: <CustomerInvoicesPage />,
      },
      {
        module: "ENGINEER_INVOICE",
        text: "Engineer Invoices",
        path: "engineer",
        isShowClient: true,
        roles: ["CLIENT", "ADMIN"],
        component: <EngineerInvoicesPage />,
      },
      {
        module: "ENGINEER_INVOICE",
        text: "",
        path: "edit/:id",
        roles: ["CLIENT", "ADMIN"],
        component: <EditInvoicePage />,
      },
      {
        module: "CUSTOMER_INVOICE",
        text: "",
        path: "edit/:id",
        roles: ["CLIENT", "ADMIN", "CUSTOMER"],
        component: <EditInvoicePage />,
      },
    ],
  },
];
export default routes;
